import Image from 'next/image';
import { ThumbnailProps } from './Thumbnail.typed';
import * as Styled from './Thumbnail.styled';

export function Thumbnail(props: ThumbnailProps) {
  const {
    children,
    image,
    aspectRatio = [1, 1],
    elevated = false,
    placeholder,
    presentation = false,
    fit = 'cover',
    alt = '',
    ...rest
  } = props;
  return (
    <Styled.Thumbnail
      {...(presentation && !!image && { image })}
      aspectRatio={aspectRatio}
      elevated={elevated}
      fit={fit}
      {...rest}
    >
      {image && !presentation && (
        <Styled.ThumbnailImage>
          <Image
            src={image}
            alt={alt}
            fill
            style={{ objectFit: fit }}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            // Using unoptimized={true} to prevent hydration mismatches,
            // This shared component is used across many features, and optimization causes
            // server/client rendering differences that result in "element detached from DOM" errors.
            unoptimized={true}
          />
        </Styled.ThumbnailImage>
      )}
      {!image && !!placeholder && (
        <div>
          <Styled.Placeholder>{placeholder}</Styled.Placeholder>
        </div>
      )}
      {!!children && <Styled.Body>{children}</Styled.Body>}
    </Styled.Thumbnail>
  );
}

export default Thumbnail;
